import { render, staticRenderFns } from "./SexoPage.vue?vue&type=template&id=e9ca69a6"
import script from "./SexoPage.js?vue&type=script&lang=js&external"
export * from "./SexoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports